import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { OnboardingProvider } from "@/contexts/OnboardingContext";
import { ArtistOnboardingChecklist } from "./ArtistOnboardingChecklist";

/**
 * Mounts the artist "Getting started" checklist globally for logged-in artists
 * across the landing page and other public/app pages.
 *
 * The artist dashboard already mounts its own OnboardingProvider + checklist
 * (with the welcome modal and spotlight tour), so we skip rendering there to
 * avoid duplicates.
 */
export function GlobalArtistOnboardingChecklist() {
  const { user, userRole, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!user) return null;
  if (userRole !== "artist") return null;

  // Avoid duplicate checklist on the artist dashboard (it mounts its own).
  if (location.pathname.startsWith("/dashboard/artist")) return null;

  // Hide on auth screens.
  if (location.pathname === "/login" || location.pathname === "/register") {
    return null;
  }

  return (
    <OnboardingProvider>
      <ArtistOnboardingChecklist />
    </OnboardingProvider>
  );
}
